export default __webpack_public_path__ + "static/media/logo-company-14.cc3e90a0.png";